import React from 'react';
import { Modal, TFVButton, Translate } from '../../../Share/components';
import PropTypes from 'prop-types';
import { isIE } from '../../../Share/utils';

function Confirmation({ isVisible = false, onClose = () => {}, onGoToCreateUser = () => {} }) {
  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={onClose}
      headerText="Bekräftelse"
      className="tv-create-license__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <p className="mb-5">
        Du har nu tecknat en licens! Fortsätt genom att skapa användare
      </p>
      <div className="justify-content-between tv-display-flex gap-4 tv-create-license__modal__footer mt-5">
        <TFVButton
          type="line-primary"
          buttonType="button"
          className="w-50"
          text="Gå tillbaka"
          onClick={onClose}
        />
        <TFVButton
          type="secondary"
          buttonType="button"
          className="w-50"
          text="Skapa användare"
          onClick={() => {
            onClose();
            onGoToCreateUser();
          }}
        />
      </div>
    </Modal>
  );
}

Confirmation.prototype = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Confirmation;
